import InfoTilesType from '~/components/@types/infoTiles';
import Mixer from '@zola/zola-ui/src/assets/images/icons/mixer.svg';
import CashFunds from '@zola/zola-ui/src/assets/images/icons/cash_funds.svg';
import FreeShipping from '@zola/zola-ui/src/assets/images/icons/free_shipping.svg';
import PriceMatching from '@zola/zola-ui/src/assets/images/icons/price_matching.svg';
import RegistryChecklist from '@zola/zola-ui/src/assets/images/icons/registry_checklist.svg';
import GroupGifting from '@zola/zola-ui/src/assets/images/icons/group_gifting.svg';
import GiftPile2 from '@zola/zola-ui/src/assets/images/icons/gift_pile_2.svg';
import AdvisorV2 from '@zola/zola-ui/src/assets/images/icons/advisor-v2.svg';
import Palette from '@zola/zola-ui/src/assets/images/icons/personalization.svg';

const tileContent: InfoTilesType[] = [
  {
    className: 'unique-gifts',
    imgSrc: Mixer,
    imgAlt: 'mixer icon',
    heading: 'Classic And Unique Gifts',
    href: '/shop/collection/new-arrivals',
  },
  {
    className: 'exchanges',
    imgSrc: CashFunds,
    imgAlt: 'cash funds icon',
    heading: 'Honeymoon Funds',
    href: '/wedding-registry/how-cash-gifts-work',
  },
  {
    className: 'free-shipping',
    imgSrc: FreeShipping,
    imgAlt: 'free shipping icon',
    heading: 'Free Shipping And Returns',
    href: '/faq/360004776432-does-zola-offer-free-shipping-and-returns-',
  },
  {
    className: 'price-matching',
    imgSrc: PriceMatching,
    imgAlt: 'price matching icon',
    heading: 'Price Matching',
    href: '/faq/115002838511-does-zola-offer-price-matching-what-is-zola-s-price-matching-policy-',
  },
  {
    className: 'gifts',
    imgSrc: `${process.env.ASSET_PATH}/static-preauth/images/WeddingRegistryBenefitsLP/everythingYouAndGuestsWant/external_gifts.svg`,
    imgAlt: 'gift icon',
    heading: 'Add Gifts From Other Stores',
    href: '/wedding-registry/apps',
  },
  {
    className: 'registry-checklist',
    imgSrc: RegistryChecklist,
    imgAlt: 'registry checklist icon',
    heading: 'Registry Checklist',
    href: '/faq/115002835252-how-do-we-start-our-zola-registry-',
  },
  {
    className: 'group-gifting',
    imgSrc: GroupGifting,
    imgAlt: 'group gifting icon',
    heading: 'Group Gifting',
    href: '/faq/115002838951-what-does-group-gifting-mean-on-my-registry-',
  },
  {
    className: 'bonus-gifts',
    imgSrc: GiftPile2,
    imgAlt: 'gift pile icon',
    heading: 'Bonus Gifts',
    href: '/wedding-registry/perks',
  },
  {
    className: 'advisor',
    imgSrc: AdvisorV2,
    imgAlt: 'registry advisor icon',
    heading: 'Top-Notch Customer Service',
    href: '/advisor',
  },
  {
    className: 'personalized',
    imgSrc: Palette,
    imgAlt: 'palette icon',
    heading: 'Personalized Registry',
    href: '/wedding-registry',
  },
];

export default tileContent;
